export const SESSION_SHOW_RESET = "SESSION_SHOW_RESET";
export const SESSION_SHOW_SET_ERROR = "SESSION_SHOW_SET_ERROR";
export const SESSION_SHOW_SET_RETRIEVED = "SESSION_SHOW_SET_RETRIEVED";
export const SESSION_SHOW_TOGGLE_LOADING = "SESSION_SHOW_TOGGLE_LOADING";
